import { computed, Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';
import { PortalContextService } from './portal-context.service';
import { TenantEnvService } from './tenant-env.service';

@Injectable({ providedIn: 'root' })
export class PortalService {
  constructor(
    private api: ApiService,
    private portalContextService: PortalContextService,
    private tenantEnvService: TenantEnvService
  ) {}

  private _portal = signal<any | null>(null);
  private _loading = signal(false);
  private _error = signal<string | null>(null);

  portal = this._portal.asReadonly();
  loading = this._loading.asReadonly();
  error = this._error.asReadonly();

  loaded = computed(() => this._portal() !== null);

  getPortals() {
    const tenantName = this.tenantEnvService.getTenantName() || this.portalContextService.getTenantName();
    const apiBaseUrl = this.tenantEnvService.getEnvBaseUrl() || undefined;
    return this.api.get(`/api/v1/portals/name/${encodeURIComponent(tenantName)}`, {}, apiBaseUrl);
  }

  setPortal(portal: any) {
    this._portal.set(portal);
  }
}
